import React from 'react';
// icons
import { ReactComponent as CloseIcon } from 'assets/icons/close.svg';
import { ReactComponent as ContentCopyIcon } from 'assets/icons/content-copy.svg';
// logic
import { useHistory } from 'react-router-dom';
// components
import ToolBarButton from '../ui/toolbar/toolBarButton';
import ToolbarTitle from '../ui/toolbar/toolbarTitle';
import RegularText from '../ui/texts/RegularText';
import ticketService from 'modules/emergencies/ticketService';
import ToolbarContainer from '../ui/containers/toolbarContainer';
import FlexContainer from '../ui/containers/flexContainer';

const TicketDetailToolbar = ({ id, is404Error }) => {
  const history = useHistory();

  return (
    <ToolbarContainer>
      <div>
        <RegularText>Details</RegularText>
        <ToolbarTitle>Ticket ID. {ticketService.utils.getFormatedId(id)}</ToolbarTitle>
      </div>
      <FlexContainer>
        {!is404Error && (
          <ToolBarButton
            withBorder={true}
            onClick={() => {
              history.push(`/emergencies/repeat/${id}`);
            }}
          >
            <ContentCopyIcon />
            Duplicate Ticket
          </ToolBarButton>
        )}
        <ToolBarButton
          withBorder={true}
          onClick={() => {
            history.push('/emergencies/');
          }}
        >
          <CloseIcon />
        </ToolBarButton>
      </FlexContainer>
    </ToolbarContainer>
  );
};

export default TicketDetailToolbar;
